// export const baseURL = "http://localhost:5000/api/";
export const baseURL = "https://apirba.msiddiquesteel.com/api/";

export const SocketURL = 'https://apirba.msiddiquesteel.com/';

// export const imageURL = "http://localhost:5000/";
export const imageURL = "https://apirba.msiddiquesteel.com";